import React, { useEffect, useState } from 'react'
import Topbar from '../components/Topbar'
import Leftbar from '../components/Leftbar'
import { Link } from 'react-router-dom'
import { getRequestedPhysioList } from '../Utils/utils'
import { toggleLoader } from '../actions/loader'
import { connect } from 'react-redux'

const RequestedPhysios = props => {
  const [users, setUsers] = useState([])
  const [limit, setLimit] = useState(10)
  const [skip, setSkip] = useState(0)
  const [isLargeScreen, setIsLargeScreen] = useState(false)
  const [totalPages, setTotalPages] = useState(1)
  // Function to detect screen width and set the state
  const handleResize = () => {
    setIsLargeScreen(window.innerWidth >= 1200) // Set true if width >= 1200px
  }
  // UseEffect hook to listen to screen size changes
  useEffect(() => {
    handleResize() // Set initial value on component mount
    window.addEventListener('resize', handleResize) // Add event listener on resize

    // Cleanup event listener when component unmounts
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getListNew = async () => {
    props.toggleLoader(true)
    var getUsers_var = await getRequestedPhysioList(limit, skip)
    console.log('Requested Physio List:', getUsers_var)
    setUsers(getUsers_var.data.data)
    setTotalPages(getUsers_var.data.metadata.totalPage)
    props.toggleLoader(false)
  }

  useEffect(() => {
    getListNew()
  }, [skip, limit])

  return (
    <>
      <body class='g-sidenav-show  bg-gray-100'>
        <div id='wrapper'>
          <Leftbar />
          <main className='main-content border-radius-lg'>
            <Topbar />

            <div className='header bg-primary pb-6'>
              <div className='container-fluid'>
                <div className='header-body'>
                  <div className='row align-items-center py-4'>
                    <div className='col-lg-6 col-7'>
                      <nav
                        aria-label='breadcrumb'
                        className='d-none d-md-inline-block ml-md-4'
                      >
                        <ol className='breadcrumb breadcrumb-links breadcrumb-dark'>
                          <li className='breadcrumb-item'>
                            <Link to='/dashboard'>
                              <i className='fas fa-home' />
                            </Link>
                          </li>
                          <li className='breadcrumb-item'>
                            <a href='#'>Request List</a>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='container-fluid mt--6'>
              <div className='row'>
                <div className='col'>
                  <div className='card'>
                    <div className='card-header border-0'>
                      <div className='row'>
                        <div className='col-9'>
                          <h3 className='mb-0'>Requested Service Providers </h3>
                        </div>
                      </div>
                    </div>
                    <div className='table-responsive'>
                      <table className='table align-items-center table-flush'>
                        <thead className='thead-light'>
                          <tr>
                            <th>User Name</th>
                            <th>Experience</th>
                            <th>Education</th>
                            <th>Phone Number</th>
                            <th>Email</th>
                            <th
                              className={
                                isLargeScreen
                                  ? 'large-address-column'
                                  : 'address-column'
                              }
                            >
                              Description
                            </th>
                            <th>Type of Interest</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users?.map(user => (
                            <tr>
                              <td className='table-user'>
                                <b className='nameee'>{user?.name}</b>
                              </td>

                              <td
                                className={
                                  isLargeScreen
                                    ? 'large-address-column'
                                    : 'address-column'
                                }
                              >
                                <span className='text-muted'>
                                  {user?.experience}{' '}
                                </span>
                              </td>
                              <td>
                                <span className='text-muted'>
                                  {user?.education}{' '}
                                </span>
                              </td>
                              <td>
                                <span className='text-muted'>
                                  {user?.phone_number
                                    ? user?.phone_number + ' '
                                    : 'N/A'}
                                </span>
                              </td>
                              <td>
                                <span className='text-muted'>
                                  {user?.email}{' '}
                                </span>
                              </td>
                              <td>
                                <span className='text-muted'>
                                  {user?.description}{' '}
                                </span>
                              </td>
                              <td>
                                <span className='text-muted'>
                                  {user.interest?.name}{' '}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {users && users.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                  {skip != 0 && (
                    <button
                      className='btn btn-primary mr-4'
                      onClick={e => {
                        setSkip(skip - 1)
                      }}
                    >
                      {' '}
                      Prev{' '}
                    </button>
                  )}
                  {users.length != 0 &&
                    users?.length == limit &&
                    totalPages > 1 && (
                      <button
                        className='btn btn-primary pull-right'
                        onClick={e => {
                          setSkip(skip + 1)
                        }}
                      >
                        {' '}
                        Next{' '}
                      </button>
                    )}
                </div>
              )}
            </div>
          </main>
        </div>
      </body>
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = state => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(RequestedPhysios)
